// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1qi0{border-radius:var(--ds-radius-medium,6px)}._189e1dm9{border-width:var(--ds-border-width-selected,2px)}\n._1dqonqa1{border-style:solid}\n._1h6dojnm{border-color:var(--ds-text-disabled,#091e4224)}\n._1bsb194s{width:14pc}\n._4t3i1et3{height:81pt}\n._5ral1dfr{object-fit:cover}", ""]);
// Exports
module.exports = exports;
